import type { ReactNode } from 'react';
import type { VirtualAccountSummary } from '@pnl/shared';
import { resultBadge, stateLabel } from '../../lib/accountStatus';
import { formatBrl, formatDateBR } from '../../lib/format';
import { Card } from './Card';
import { StatusBadge } from './StatusBadge';

interface Props {
  account: VirtualAccountSummary;
  marketCode?: 'B3' | 'FOREX';
}

const phaseTitle: Record<VirtualAccountSummary['phase'], string> = {
  TEST: 'Conta PnL em Teste',
  FUNDED: 'Conta PnL Funded',
  LIVE: 'Conta PnL Live',
};

function Row({ label, children, last }: { label: string; children: ReactNode; last?: boolean }) {
  return (
    <div
      className={
        'flex items-center justify-between gap-3 py-3 ' + (last ? '' : 'border-ink-800 border-b')
      }
    >
      <span className="text-ink-400 text-sm">{label}</span>
      <span className="text-ink-100 text-right text-sm font-semibold">{children}</span>
    </div>
  );
}

/** Card lateral com a ficha da conta (espelha o "FTMO Challenge"). */
export function AccountInfoCard({ account, marketCode }: Props) {
  const platform = marketCode === 'FOREX' ? 'BlackArrow' : 'Profit';
  const badge = resultBadge(account.result, account.phase);

  return (
    <Card title={phaseTitle[account.phase]}>
      <div className="px-5 py-1">
        <Row label="Resultado">
          <StatusBadge label={badge.label} tone={badge.tone} />
        </Row>
        <Row label="Estado">{stateLabel(account.state)}</Row>
        <Row label="Fase">Única</Row>
        <Row label="Início">{formatDateBR(account.openedAt)}</Row>
        <Row label="Fim">Ilimitado</Row>
        <Row label="Tamanho da conta">{formatBrl(account.capitalCents)}</Row>
        <Row label="Tipo de conta">PnL</Row>
        <Row label="Plataforma" last>
          {platform}
        </Row>
      </div>
    </Card>
  );
}
